import { css } from '@emotion/core';

export default () => ({
  label: css`
    opacity: 0.4;
    position: absolute;
    right: 19px;
    top: 55%;
    transform: translateY(-50%);
  `,
  input: css`
    padding: 14px;
    border: 1px solid #ddd;
    width: 100%;
    border-radius: 2px;

    &::placeholder {
      font-size: 1.3em;
    }

    &:focus {
      outline: none;
      border: 1px solid rgb(0, 61, 176);
    }
  `,
  wrapper: css`
    padding: 8px 8px;
    padding-bottom: 9px;
    position: relative;
  `
});
